import { LogLevel } from "@azure/msal-browser";
import { getConfig } from "../config/runtimeConfig";
import { localConfig } from "../config/localConfig";



export const msalConfig = {
    get auth() {
        return {
            clientId: getConfig().REACT_APP_CLIENT_ID,
            authority: `https://login.microsoftonline.com/${getConfig().REACT_APP_TENANT_ID}`,
            redirectUri: getConfig().REACT_APP_REDIRECT_URI,
        };
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        },
        allowRedirectInIframe: true, // Allow redirects in iframes
    }
};